import { SignataireEntity } from "./signataire.entity";

export class SignatairePdpEntity extends SignataireEntity {
	
}